module.exports = __webpack_public_path__ + "static/img/naniungo-slide-20.3a0cf54b.jpg";